import { render, staticRenderFns } from "./MenuNavigation.vue?vue&type=template&id=041c0682&scoped=true"
import script from "./MenuNavigation.vue?vue&type=script&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&lang=js"
import style0 from "./MenuNavigation.vue?vue&type=style&index=0&id=041c0682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041c0682",
  null
  
)

export default component.exports